import { useCallback } from 'react';
import { bridge } from 'shared/src/utils';
import type { PromotionsBanner } from 'shared/src/api';

export const useLogClickShortBanner = () => {
  return useCallback((banner: PromotionsBanner) => {
    bridge.logAnalyticsEvent({
      name: 'CLICK_SHORT_BANNER',
      channel: ['firebase', 'facebook', 'amplitude', 'braze', 'ablylog'],
      analytics: {
        SCREEN: 'GOODS_DETAIL',
        EVENT_TYPE: 'CLICK_SHORT_BANNER',
        // GROUP_SNO:banner.
        ...banner.logging,
      },
    });
  }, []);
};
